export const removeMessage =
	(messageId: string) =>
	(currentMessageIds: string[]): string[] =>
		currentMessageIds.filter((id) => id !== messageId);
